"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Menu = require("./Menu");
Object.keys(_Menu).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Menu[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Menu[key];
    }
  });
});
var _MenuOptionButton = require("./MenuOptionButton");
Object.keys(_MenuOptionButton).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MenuOptionButton[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _MenuOptionButton[key];
    }
  });
});